import { post } from '@classic/Foundation/Services/ApiService'
import { queryClient } from '@core/Data/ReactQuery'
import {
  MfaVerificationRequestData,
  MfaCompleteVerificationRequestData,
  MfaStartAttributeVerificationResponseData,
} from '@mobi/api-types/src/mfa'
import { throwApiError } from '../utils'
import {
  CognitoUnauthorizedError,
  isCognitoUserAuthenticated,
} from './useCognitoUserIsAuthenticated'
import { invalidateCognitoUserQuery } from '@core/Data/Account/useCognitoUser'

export async function startCognitoAttributeVerification(body: MfaVerificationRequestData) {
  const isAuthenticated = await isCognitoUserAuthenticated()

  if (!isAuthenticated) {
    throw new CognitoUnauthorizedError()
  }

  try {
    const response = await post<MfaStartAttributeVerificationResponseData>({
      url: '/api/mfa/start-verification',
      body,
    })
    return response
  } catch (error: unknown) {
    return throwApiError(error)
  }
}

export const useMfaCompleteVerification = () => {
  async function completeVerification(body: MfaCompleteVerificationRequestData) {
    try {
      const response = await post({
        url: '/api/mfa/complete-verification',
        body,
      })

      invalidateCognitoUserQuery(queryClient)

      return response
    } catch (error: unknown) {
      return throwApiError(error)
    }
  }
  return { completeVerification }
}
